import React from 'react';
import styled from 'styled-components';
import KubitTooltip from '../../../../components/KubitTooltip';
import { dashboardFolderTooltipOption } from '../../../../components/KubitTooltip/globalTooltips';
import { SvgIcon } from '../../../../components/Icon';
import { theme } from '../../../../styles/theme';

interface IProps {
  onClick: () => void;
  disabled: boolean;
}

const Container = styled.button`
  display: inline-flex;
  align-items: center;
  column-gap: 4px;
  font: inherit;
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.secondary800};
  &:not(:disabled):hover {
    color: ${theme.colors.mainBlue};
    cursor: pointer;
  }
`;

const DashboardFolderWidgetCreateNewAction = ({
  onClick,
  disabled,
}: IProps) => {
  return (
    <KubitTooltip noOpenDelay={true} {...dashboardFolderTooltipOption}>
      <Container type="button" onClick={onClick} disabled={disabled}>
        <SvgIcon
          name="folder-plus"
          width={16}
          height={16}
          customFill="currentColor"
        />
        Add New Folder
      </Container>
    </KubitTooltip>
  );
};

export default DashboardFolderWidgetCreateNewAction;
